import { Activity, Bot, CheckCircle2, History, Library } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { TabsContent } from '@/components/ui/tabs'
import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { AgentsTab } from './AgentsTab'
import { EvalsTab } from './EvalsTab'
import { KnowledgeTab } from './KnowledgeTab'
import { SessionsTab } from './SessionsTab'
import { TracesTab } from './TracesTab'

const VALID_TABS = ['agents', 'knowledge', 'evals', 'sessions', 'traces'] as const

function getTabFromHash(): string {
  const raw = window.location.hash.replace(/^#/, '').split('?', 1)[0]
  return (VALID_TABS as readonly string[]).includes(raw) ? raw : 'agents'
}

export function AgentTools() {
  const [tab, setTab] = useState(getTabFromHash)

  useEffect(() => {
    function onHashChange() {
      setTab(getTabFromHash())
    }
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  function handleTabChange(value: string) {
    setTab(value)
    window.location.hash = value
  }

  return (
    <>
      <Helmet>
        <title>Agent Tools</title>
      </Helmet>

      <div className="space-y-6">
        <h1 className="text-2xl font-semibold">Agent Tools</h1>

        <ToggleTabs
          value={tab}
          onValueChange={handleTabChange}
          className="w-full"
          items={[
            { value: 'agents', icon: <Bot />, label: 'Agents' },
            { value: 'knowledge', icon: <Library />, label: 'Knowledge' },
            { value: 'evals', icon: <CheckCircle2 />, label: 'Evals' },
            { value: 'sessions', icon: <History />, label: 'Sessions' },
            { value: 'traces', icon: <Activity />, label: 'Traces' },
          ]}
        >
          <TabsContent value="agents" className="mt-4">
            <AgentsTab />
          </TabsContent>

          <TabsContent value="knowledge" className="mt-4">
            <KnowledgeTab />
          </TabsContent>

          <TabsContent value="evals" className="mt-4">
            <EvalsTab />
          </TabsContent>

          <TabsContent value="sessions" className="mt-4">
            <SessionsTab />
          </TabsContent>

          <TabsContent value="traces" className="mt-4">
            <TracesTab />
          </TabsContent>
        </ToggleTabs>
      </div>
    </>
  )
}
